<template>
  <transition name="modal-fade">
    <div v-if="toolbarvisible" class="toolbar">
      <div class="toolbar-content">
        <div class="title">
          <div class="tips iconfont">&#xe693; 提示词助手</div>
          <div class="close" @click="closeModal">&times;</div>
        </div>
        <div class="call-words"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ToolBar',
  props: {
    toolbarvisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:toolbarvisible', false)
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .toolbar-content,
.modal-fade-leave-active .toolbar-content {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.modal-fade-enter-from .toolbar-content,
.modal-fade-leave-to .toolbar-content {
  opacity: 0;
  transform: scale(0.5);
}

.toolbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  .toolbar-content {
    display: flex;
    flex-direction: column;
    width: 900px;
    height: auto;
    background-color: @font_white;
    border-radius: 20px;
    padding: 15px;
    cursor: pointer;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 50px;

      .tips {
        height: 30px;
        font-size: 28px;
        line-height: 30px;
        text-align: left;
        color: @morejoy;
      }

      .close {
        color: @morejoy;
        font-size: 28px;
      }
    }

    .call-words {
      width: 100%;
      height: 180px;
      border: 2px solid @morejoy;
      border-radius: @border_radius;
    }
  }
}
</style>
